const translations = {
    fr: {
        startButton: "C'est parti !",
        welcomeMessage: "Bienvenue dans le jeu !",
        message: "Veuillez entrer le code d'accès pour commencer",
        accessCode: "Code confidentiel",
        validate: "Valider",
        selectLanguage: "🌍 Sélectionnez une langue",
        errorLang: "⚠ Veuillez sélectionner une langue.",
        needHelp: "Besoin d'aide ?",
        loadingInfo: "Chargement des données en cours",
        langNotAvailable: "Ce jeu n'existe pas dans la langue sélectionnée.",
        changeLangInstruction: "Veuillez changer la langue depuis le menu pour y accéder.",
        confirmEndGameMessage: "Voulez-vous vraiment terminer et effacer les indices ?",
        cancel: "Annuler",
        confirm: "Confirmer",
        backToHome: "Retour à l'accueil",
        errorLoadingGame : "Une erreur est survenue. Le jeu ne peux pas être chargé.", 
        loading : "Chargement en cours...",
        noLangAvailable: "Aucune langue n'est disponible pour ce jeu.",
        howManyPlayers: "Combien de joueurs participent à cette chasse ?",
        nbPlayersPlaceholder: "Nombre de joueurs",
    },
    en: {
        startButton: "Let's go!",
        welcomeMessage: "Welcome to the game!",
        message: "Please enter the access code to start",
        accessCode: "Confidential code",
        validate: "Validate",
        selectLanguage: "🌍 Select a language",
        errorLang: "⚠ Please select a language.",
        needHelp: "Need help?",
        loadingInfo: "Loading data...",
        langNotAvailable: "This game is not available in the selected language.",
        changeLangInstruction: "Please change the language from the menu to access it.",
        confirmEndGameMessage: "Do you really want to finish and erase the clues?",
        cancel: "Cancel",
        confirm: "Confirm",
        backToHome: "Back to home"
    },
    de: {
        startButton: "Los geht's!",
        welcomeMessage: "Willkommen im Spiel!",
        message: "Bitte geben Sie den Zugangscode ein, um zu starten",
        accessCode: "Geheimer Code",
        validate: "Bestätigen",
        selectLanguage: "🌍 Sprache auswählen",
        errorLang: "⚠ Bitte wählen Sie eine Sprache aus.",
        needHelp: "Brauchen Sie Hilfe?",
        loadingInfo: "Daten werden geladen...",
        langNotAvailable: "Dieses Spiel ist in der ausgewählten Sprache nicht verfügbar.",
        changeLangInstruction: "Bitte ändere die Sprache im Menü, um darauf zuzugreifen.",
        confirmEndGameMessage: "Möchten Sie wirklich beenden und die Hinweise löschen?",
        cancel: "Abbrechen",
        confirm: "Bestätigen",
        backToHome: "Zur Startseite"
    },
    es: {
        startButton: "¡Vamos!",
        welcomeMessage: "¡Bienvenido al juego!",
        message: "Por favor, introduzca el código de acceso para comenzar",
        accessCode: "Código confidencial",
        validate: "Validar",
        selectLanguage: "🌍 Selecciona un idioma",
        errorLang: "⚠ Por favor, selecciona un idioma.",
        needHelp: "¿Necesitas ayuda?",
        loadingInfo: "Cargando datos...",
        langNotAvailable: "Este juego no está disponible en el idioma seleccionado.",
        changeLangInstruction: "Por favor, cambia el idioma desde el menú para acceder.",
        confirmEndGameMessage: "¿Realmente quieres terminar y borrar las pistas?",
        cancel: "Cancelar",
        confirm: "Confirmar",
        backToHome: "Volver al inicio"
    },
    it: {
        startButton: "Si parte!",
        welcomeMessage: "Benvenuto nel gioco!",
        message: "Inserisci il codice di accesso per iniziare",
        accessCode: "Codice confidenziale",
        validate: "Conferma",
        selectLanguage: "🌍 Seleziona una lingua",
        errorLang: "⚠ Seleziona una lingua, per favore.",
        needHelp: "Hai bisogno di aiuto?",
        loadingInfo: "Caricamento dei dati...",
        langNotAvailable: "Questo gioco non è disponibile nella lingua selezionata.",
        changeLangInstruction: "Per favore, cambia la lingua dal menu per accedere.",
        confirmEndGameMessage: "Vuoi davvero terminare ed eliminare gli indizi?",
        cancel: "Annulla",
        confirm: "Conferma",
        backToHome: "Torna alla home"
    }
};

export default translations;
